var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6767 9.61832C20.7362 10.9055 21.7659 11.549 22.1191 12.3731C22.4275 13.0927 22.4275 13.9073 22.1191 14.627C21.7659 15.4509 20.7362 16.0945 18.6767 17.3818L9.00356 23.4275C6.71775 24.8561 5.57483 25.5705 4.63167 25.4945C3.80955 25.4284 3.05594 25.0109 2.56418 24.3487C2 23.5891 2 22.2414 2 19.5458V7.4543C2 4.75876 2 3.411 2.56418 2.65138C3.05594 1.98925 3.80955 1.57157 4.63167 1.50546C5.57483 1.42965 6.71775 2.14397 9.00356 3.5726L18.6767 9.61832Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPlayIcon);
export default __webpack_public_path__ + "static/media/BlackPlayIcon.d7bcf6d84d9858f43db8158c3945e9b7.svg";
export { ForwardRef as ReactComponent };